module.exports = __webpack_public_path__ + "static/media/uk.00a2853f.svg";